import { t } from "@lingui/macro";
import { RelayEnvironmentProvider, useRelayEnvironment } from "react-relay";

import { WithRealSafeAreaInsets } from "@/hooks/useRealSafeAreaInsets";
import { Button } from "@whoosh/design-system/src/components/controls";
import { CloseIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

import { NotificationsUpdateModalQueryWrapper } from "./NotificationsUpdateModalQueryWrapper";

type NotificationsUpdateModalProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  showGuide?: boolean;
  onRequestVerification?: (mode: "email" | "phone") => void;
  onSaveSuccess?: () => void;
};

export const NotificationsUpdateModal = ({
  isOpen,
  setIsOpen,
  showGuide,
  onRequestVerification,
  onSaveSuccess,
}: NotificationsUpdateModalProps) => {
  const environment = useRelayEnvironment();
  const onClose = () => setIsOpen(false);

  return (
    <WithRealSafeAreaInsets>
      <StandardModal
        isOpen={isOpen}
        onClose={onClose}
        hideCloseButton
        upperNode={
          <Box
            flex={1}
            width="100%"
            alignItems="center"
            justifyContent="center"
            position="relative"
            paddingVertical={6}
          >
            <Box position="absolute" left={0}>
              <Button
                variant="secondary"
                accessibilityLabel={t`Close`}
                testID="notifications-update-modal-close-button"
                onPress={onClose}
                leftIcon={<CloseIcon />}
              />
            </Box>
            <Text variant="mainBaseSemiBold">{t`Notifications`}</Text>
          </Box>
        }
        lockFullHeight
        hideFooterPadding
        disableContentScroll
        content={
          <RelayEnvironmentProvider environment={environment}>
            <Box flex={1}>
              <NotificationsUpdateModalQueryWrapper
                onClose={onClose}
                showGuide={showGuide}
                onRequestVerification={onRequestVerification}
                onSaveSuccess={onSaveSuccess}
              />
            </Box>
          </RelayEnvironmentProvider>
        }
      />
    </WithRealSafeAreaInsets>
  );
};
